[
  {
    "code": "GW-BS",
    "name": "Bissau"
  },
  {
    "code": "GW-L",
    "name": "Leste"
  },
  {
    "code": "GW-N",
    "name": "Norte"
  },
  {
    "code": "GW-S",
    "name": "Sul"
  }
]